<template>
  <fin-header-footer-container v-resize="calcTableHeight"
                               :vertical-centered="true"
                               footer-color="#f5f8f9"
                               header-color="#fff"
                               page-color="#f5f8f9">
    <template #header>
      <v-container :class="'pageHeader ' + ($vuetify.breakpoint.mdAndUp ? 'py-9' : 'py-3')" fluid>
        <v-row v-mutate="calcTableHeight">
          <v-col :class="$vuetify.breakpoint.xs ? 'pb-0' : ''"
                 style="max-width: 566px; margin: 0 auto; text-align: center;">
            <h1>Wertpapiere auswählen</h1>
            <p :class="$vuetify.breakpoint.xs ? 'mt-3 mb-3' : 'mt-3 mb-5'">
              <fin-lexicon-text auto-solve
                                text="Hier siehst du die Wertpapiere, die am besten zu deinem Archetypen und dem dazugehörigen Strategiemodell passen:"/>
            </p>
            <div v-if="archetype" :class="$vuetify.breakpoint.xs ? '' : 'px-3'" id="onboarding-strategy-model"
                 style="display: flex; justify-content: center; align-items: center; position: relative;">
              <fin-archetype-avatar :archetype-id="archetype.id"
                                    :tooltip="archetype.title"
                                    class="ml-6 mr-3"/>
              <p class="mb-0">
                <span class="mr-2">Strategiemodell:</span>
                <v-btn elevation="0"
                       style="vertical-align: baseline"
                       text
                       @click="showStrategieDetailsDialog = true">
                  {{ strategy.name }}
                </v-btn>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <fin-dialog v-model="showStrategieDetailsDialog" fullscreen persistent dense>
        <fin-strategy-details :asset-class-i-d="assetType.id"
                              :strat-id="strategy.id"
                              overview-only/>
      </fin-dialog>
    </template>

    <template #default>
      <v-row align="center" class="mb-0 py-0" justify="center">
        <v-col v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               class="py-0" cols="12">
          <fin-strategy-instruments-data-table v-model="selectedInstruments"
                                               :asset-class-id="assetType.id"
                                               :show-instrument-profile-as="'dialog'"
                                               :show-select="true"
                                               :strategy="strategy"
                                               @extendedViewChanged="extendedViewChanged"
                                               :table-height="tableHeight"
                                               ref="table"
          >
            <template #footer-actions>
              <v-btn class="mr-4 mr-sm-6 pa-2" light
                     @click="cancel"
                     tile>
                <span class="start-button-text px-2">Abbrechen</span>
              </v-btn>
              <v-btn :disabled="!hasSelection"
                     @click="confirm"
                     class="pa-2"
                     dark>
                <span class="start-button-text px-2">Wertpapieranzahl festlegen</span>
              </v-btn>
            </template>
          </fin-strategy-instruments-data-table>
        </v-col>
      </v-row>
    </template>


  </fin-header-footer-container>
</template>

<script>
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import FinHeaderFooterContainer from '@/components/common/HeaderFooterContainer/index'
import {mapActions} from 'vuex'
import FinArchetypeAvatar from "@/components/common/ArchetypeAvatar"
import FinStrategyInstrumentsDataTable from "@/components/common/StrategyInstrumentsDataTable"
import FinStrategyDetails from "@/views/protected/finStrategy/StrategyDetails"
import AmplitudePush from "@/mixins/AmplitudePush"

export default {
  name: 'fin-fill-portfolio-desktop',
  mixins: [AmplitudePush],
  components: {
    FinStrategyDetails,
    FinStrategyInstrumentsDataTable,
    FinArchetypeAvatar,
    FinHeaderFooterContainer,
    FinLexiconText,
  },
  props: {
    value: {
      type: Array
    },
    archetype: {
      type: Object
    },
    strategy: {
      type: Object
    },
    assetType: {
      type: Object
    }
  },
  data() {
    return {
      selectedInstruments: this.value ? this.value.map(me => {
        return {
          ...me,
          instrumentId: me.instrument.id
        }
      }) : [],
      showStrategieDetailsDialog: false,
      tableHeight: undefined,
      mode: undefined
    }
  },
  computed: {
    hasSelection() {
      return this.selectedInstruments.length > 0
    }
  },
  methods: {
    ...mapActions('archetype', ['loadArchetypes']),
    extendedViewChanged() {
      this.$nextTick(() => setTimeout(this.calcTableHeight, 100))
    },
    cancel() {
      this.$emit('cancel')
    },
    calcTableHeight() {
      const tableTopPosition = this.$refs.table.$el.querySelector('.v-data-table')?.getBoundingClientRect()?.top || 0
      const mobileBottomNavHeight = this.$el.querySelector('.v-bottom-navigation--fixed')?.getBoundingClientRect()?.height || 0
      const paginatorHeight = this.$refs.table.$el.querySelector('.v-data-footer')?.getBoundingClientRect()?.height || 58
      const footerActionsRowHeight = this.$refs.footerActionsRow?.getBoundingClientRect()?.height || 36
      let tableHintsHeight = 15
      try {
        tableHintsHeight = document.querySelector('.hints').getBoundingClientRect()?.height || 15
      } catch (e) {
        tableHintsHeight = 15
      }
      const paddingBetweenTableAndActions = 12
      const paddingAfterActions = 16
      const off = mobileBottomNavHeight + tableTopPosition + paginatorHeight + footerActionsRowHeight +
        tableHintsHeight + paddingBetweenTableAndActions + paddingAfterActions
      this.tableHeight = window.innerHeight > off + 150 ?
        (window.innerHeight - off) + 'px' :
        null
    },
    confirm() {
      this.pushToAmplitude({
        'event': 'fincraft_' + this.mode + '_portfolio_fill_bucket',
        'step': this.mode + '_portfolio_distribution',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      // map selected shares back to array of instrument and count
      const newBucket = this.selectedInstruments.map(me => {
        const oldEntry = this.value ? this.value.find(org => org.instrument.id === me.instrument.id) : []
        const oldCount = oldEntry ? oldEntry.count : 0

        return {
          instrument: {
            close: me.instrument.close,
            closeDate: me.instrument.closeDate,
            id: me.instrument.id,
            name: me.instrument.name,
            exchange: me.instrument.latestPrice.exchangeName,
            latestPrice: me.instrument.latestPrice
          },
          count: oldCount
        }
      })
      this.$emit('input', newBucket)
    }
  },
  mounted() {
    this.loadArchetypes()
    this.mode = this.$route.fullPath.includes('finStrategist') ? 'finStrategist' : 'onboarding'
  }
}
</script>

<style lang="scss" scoped>

@media only screen and (max-width: 600px) {
  ::v-deep .header {
    position: relative !important;
  }

  ::v-deep .content {
    padding-top: 0 !important;
  }
}
</style>
